import { css } from "@emotion/react";

const divider =
  dividerColor =>
  ({ theme }) => css`
    margin: ${theme.space[5]}px 0;
    background-color: ${dividerColor};
    @media (min-width: ${theme.screenSizes.mdMax}) {
      margin: ${theme.space[6]}px 0;
    }
  `;

const button = (buttonColor, buttonText) => props => css`
  background-color: ${buttonColor};
  color: ${buttonText};
  height: 44px;
  font-weight: 400;

  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    height: 52px;
  }
`;

export const addStyles = { divider, button };
